import React, { useId } from 'react';
import { Check } from 'lucide-react';
interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
}
export function Checkbox({
  label,
  id,
  className = '',
  ...props
}: CheckboxProps) {
  const checkboxId = id || useId();
  return <div className="flex items-start" data-id="element-286">
      <div className="flex items-center h-5" data-id="element-287">
        <input id={checkboxId} type="checkbox" className="w-4 h-4 text-[#0176d3] border-gray-300 rounded focus:ring-[#0176d3] cursor-pointer" {...props} data-id="element-288" />
      </div>
      {label && <label htmlFor={checkboxId} className="ml-2 text-sm text-[#3e3e3c] cursor-pointer select-none" data-id="element-289">
          {label}
        </label>}
    </div>;
}